import React from "react";
import { Reveal } from "@/components/site/primitives";
import { PROGRAMS } from "@/content/worldFarmers";

/**
 * PhaseImmersive
 * The five-phase mentorship path shown in the Immersive style: a compact
 * header with the mentorship intro, followed by a 5-column grid of phase
 * cards (all visible at once, no horizontal scroll).
 */
export const PhaseImmersive = () => {
  const { mentorship } = PROGRAMS;
  return (
    <section id="phases" aria-labelledby="phases-heading" className="wf-section bg-[var(--wf-cream)]">
      <div className="wf-container">
        <Reveal>
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="w-fit rounded-full bg-[rgba(47,93,58,0.10)] px-3 py-1 text-xs font-semibold text-[var(--wf-green-text)]">
                {mentorship.badge}
              </span>
              <h2 id="phases-heading" className="mt-3 font-serif text-3xl font-semibold text-[var(--wf-ink)] sm:text-4xl lg:text-5xl">
                {mentorship.title}
              </h2>
            </div>
            <p className="max-w-md text-sm leading-6 text-muted-foreground md:text-right">
              {mentorship.body}
            </p>
          </div>
        </Reveal>

        <Reveal>
          <div className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-5">
            {mentorship.phases.map((p) => (
              <div
                key={p.n}
                data-testid={`program-phase-${p.n}`}
                className="group relative flex h-full flex-col overflow-hidden rounded-sm border border-[var(--wf-border)] bg-[var(--wf-paper)] p-5 shadow-[var(--wf-shadow-sm)] transition-[box-shadow,transform] duration-300 hover:shadow-[var(--wf-shadow)] motion-safe:hover:-translate-y-1.5"
              >
                <span className="relative flex h-11 w-11 items-center justify-center rounded-full bg-[var(--wf-maroon)] font-serif text-lg font-semibold text-[var(--wf-paper)]">
                  {p.n}
                </span>
                <p className="relative mt-4 text-[11px] font-semibold uppercase tracking-[0.14em] text-[var(--wf-green-text)]">
                  Phase {p.n}
                </p>
                <h3 className="relative mt-1 font-serif text-base font-semibold leading-snug text-[var(--wf-ink)]">
                  {p.title}
                </h3>
                <p className="relative mt-2 text-xs leading-5 text-muted-foreground">{p.text}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
